import React from "react";
import { FaUser, FaUsers, FaDollarSign, FaBox } from "react-icons/fa"; // Install with `npm i react-icons`

interface ParticipantProgressCardProps {
  personalAmount: string;
  personalItems: string;
  teamAmount: string;
  teamItems: string;
}

const ParticipantProgressCard: React.FC<ParticipantProgressCardProps> = ({
  personalAmount,
  personalItems,
  teamAmount,
  teamItems,
}) => {
  return (
    <div className="container mt-4">
      <div className="card shadow-sm p-4">
        <h2 className="card-title text-center fw-bold mb-4">Progress Overview</h2>

        {/* Bootstrap Grid Layout */}
        <div className="row">
          {/* Personal Progress */}
          <div className="col-md-6">
            <div className="card bg-light border-0 shadow-sm p-3">
              <h3 className="fw-semibold d-flex align-items-center">
                <FaUser className="text-danger me-2" size={22} /> Personal
              </h3>
              <p className="mt-2">
                <FaDollarSign className="text-warning me-1" /> <strong>Amount:</strong> {personalAmount}
              </p>
              <p>
                <FaBox className="text-success me-1" /> <strong>Sold Items:</strong> {personalItems}
              </p>
            </div>
          </div>

          {/* Team Progress */}
          <div className="col-md-6 mt-3 mt-md-0">
            <div className="card bg-light border-0 shadow-sm p-3">
              <h3 className="fw-semibold d-flex align-items-center">
                <FaUsers className="text-primary me-2" size={22} /> Team
              </h3>
              <p className="mt-2">
                <FaDollarSign className="text-warning me-1" /> <strong>Amount:</strong> {teamAmount}
              </p>
              <p>
                <FaBox className="text-success me-1" /> <strong>Sold Items:</strong> {teamItems}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParticipantProgressCard;
